import { EventType } from './event-type';

export type EventHandler = (event: EventType, data: any) => Promise<void>;

export type Logger = {
	logEvent: (event: EventType, data?: any) => void;
	addEventHandler: (handler: EventHandler) => void;
	setVisibility: (isVisible: boolean) => void;
};

type EventAndData = {
	isPending: boolean;
	event: EventType,
	data: any
};

export const createLogger = () => {
	const handlers: EventHandler[] = [];
	const pendingEvent: EventAndData = {
		isPending: false,
		event: EventType.FIRST_OPEN,
		data: {}
	};
	// let pendingEventData: any = {};
	let isWidgetVisible = false;

	return {
		setVisibility: (isVisible: boolean) => {
			isWidgetVisible = isVisible;
			if (isWidgetVisible && pendingEvent.isPending) {
				handlers.forEach((handler) => handler(pendingEvent.event, pendingEvent.data));
				pendingEvent.isPending = false;
			}
		},
		logEvent: (event: EventType, data: any = {}) => {
			if (isWidgetVisible || event === EventType.LOAD || event === EventType.OPEN || event === EventType.FIRST_OPEN) {
				handlers.forEach((handler) => handler(event, data));
			} else {
				pendingEvent.isPending = true;
				pendingEvent.event = event;
				pendingEvent.data = data;
			}
			return Promise.resolve();
		},
		addEventHandler: (handler: EventHandler) => {
			handlers.push(handler);
			const removeFn = () => {
				const idx = handlers.indexOf(handler);
				handlers.slice(idx, 1);
			};

			return removeFn;
		}
	};
};
